import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateDeclineClickedPayload {
  shiftId: string;
  professionalId?: string;
  offerId?: string;
  candidateNumber?: number;
  candidateCount?: number;
}

/**
 * Fires when an office clicks the "Decline" button on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:decline_clicked
 */
export function fireConfirmCandidateDeclineClicked(
  payload: IConfirmCandidateDeclineClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:decline_clicked', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
    offer_id: payload.offerId,
    candidate_number: payload.candidateNumber,
    candidate_count: payload.candidateCount,
  });
}
